var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.45072 23.2447C7.03758 24.5714 8.3657 25.4999 9.9073 25.4999C11.4489 25.4999 12.777 24.5714 13.3639 23.2447H6.45072Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90686 2.88851C10.9242 2.88851 11.901 3.068 12.8074 3.39662V3.28496C12.8074 1.74932 11.5581 0.5 10.0225 0.5H9.79173C8.25609 0.5 7.00677 1.74932 7.00677 3.28496V3.3952C7.91275 3.06756 8.88926 2.88851 9.90686 2.88851Z",
    fill: "#444444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0614 21.7774H0.752975C0.406603 21.7774 0.0893323 21.5438 0.0172897 21.205C-0.0540192 20.8695 0.0988694 20.5384 0.409049 20.3951C0.482656 20.3474 1.03669 19.96 1.59137 18.7879C2.61009 16.6354 2.82392 13.6033 2.82392 11.4387C2.82392 7.53309 6.00137 4.35574 9.90693 4.35574C13.8032 4.35574 16.9748 7.51778 16.9899 11.4106C16.9902 11.4199 16.9904 11.4293 16.9904 11.4387C16.9904 13.6033 17.2043 16.6354 18.223 18.7879C18.7777 19.96 19.3316 20.3474 19.4053 20.3951C19.7155 20.5384 19.8684 20.8695 19.7971 21.205C19.725 21.5438 19.4078 21.7774 19.0614 21.7774Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.c1f26ce20e348674b9de5e8c80a95575.svg";
export { ForwardRef as ReactComponent };